import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase } from './ApiBase'

export namespace ApiTaLi070 {
  // GET parameters
  export namespace Get {
    // API Request
    export interface Request {
      query: {
        // 遷移先コード
        // 'question': 質問相談アプリ
        // 'effort'：努力賞システム
        transition: 'question' | 'effort'
      }
    }

    // API Response
    export interface Response {
      url: string // 遷移用 URL
    }

    // API Path
    export const path: string = '/ta/children/sso'
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, string> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<string, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        url: '',
      }
      // エラー時のレスポンス構造サンプル
      const validationErrorSample: string = 'error sample'

      // API呼び出し
      return this.callbackWrapper<Get.Response, string, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
